import Vue from 'vue'
import Router from 'vue-router'
import order from '@/pages/mine/order'
import classification from '@/pages/classification/classification'//分类
import my from '@/pages/my/my'//我的
import ShoppingCart from '@/pages/ShoppingCart/ShoppingCart'//购物车
import customerservice from '@/pages/customerservice/customerservice'//客服
import index from '@/pages/index/index'//首页
import index2 from '@/pages/index/index2'//首页2
import notice from '@/pages/notice/notice'//公告
import noticedetail from '@/pages/notice/noticedetail'//公告详情
import helpCenter from '@/pages/helpCenter/helpCenter'//帮助中心
import newPeple from '@/pages/helpCenter/new'//帮助中心
import disturb from '@/pages/helpCenter/disturb'//帮助中心
import service from '@/pages/helpCenter/service'//帮助中心
import haibei from '@/pages/helpCenter/haibei'//帮助中心
import plus from "@/pages/activity/plus"; //plus




//实物卡
import cardlist from '@/pages/card/cardlist'//实物卡列表
import cardDetail from '@/pages/card/cardDetail'//实物卡列表

import orderDetails from '@/pages/mine/orderDetails'//订单详情
import exchange from '@/pages/mine/exchange'//退换货
import shippingAddress from '@/modules/orders/pages/shippingAddress'
import allComments from '@/modules/orders/pages/allComments'
import onlyRefund from '@/modules/orders/pages/onlyRefund'
import Refundclosed from '@/modules/orders/pages/Refundclosed'
import toexamine from '@/modules/orders/pages/toexamine'//审核资料
import Refundsuccessful from '@/modules/orders/pages/Refundsuccessful'
import Aftersale from '@/modules/orders/pages/Aftersale'
import Returning from '@/modules/orders/pages/Returning'
import Applying from '@/modules/orders/pages/Applying'
import Applyreturn from '@/modules/orders/pages/Applyreturn'
import afterservice from '@/modules/orders/pages/afterservice'
import Aftermarket from '@/modules/orders/pages/Aftermarket'
import Collection from '@/modules/orders/pages/Collection'
import Emptycollection from '@/modules/orders/pages/Emptycollection'
import personaldata from '@/modules/orders/pages/personaldata'
import personalinformation from '@/modules/orders/pages/personalinformation'
import Extractcarmine from '@/modules/orders/pages/Extractcarmine'//虚拟商品
// import exchange from '@/modules/orders/pages/exchange'
// import Sharingposters from '@/modules/orders/pages/Sharingposters'
import logistics from '@/modules/orders/pages/logistics'
import equity from '@/modules/orders/pages/equity'
import evaluatingCommodities from '@/modules/orders/pages/evaluatingCommodities'
import search from '@/modules/orders/pages/search'
import paymentSuccessful from '@/modules/orders/pages/paymentSuccessful'


import invoice from '@/modules/orders/pages/invoice'
import editAddress from '@/modules/orders/pages/editAddress'
import editReceived from '@/modules/orders/pages/editReceived'




import productDetail from '@/pages/product/productDetail'
import productDetails from '@/pages/product/productDetails'
import productDetailsDiabled from '@/pages/product/productDetailsDiabled' //仅预览


import productList from '@/pages/product/productList'
import seckill from '@/modules/product/pages/seckill'



import seckillList from '@/pages/activity/seckill' //秒杀专题
import groupList from '@/pages/activity/group' //拼团专题
import shareBill from '@/pages/activity/shareBill' //邀请好友拼单
import giftCoupon from '@/pages/activity/giftCoupon' //礼品卷
import givingMonth from '@/pages/activity/givingMonth' //感恩月
import promotion from '@/pages/activity/promotion' //活动页
import nypromotion from '@/pages/activity/nypromotion' //活动页
import zqpromotion from '@/pages/activity/zqpromotion' //活动页
import gqpromotion from '@/pages/activity/gqpromotion' //活动页
import jjxdpromotion from '@/pages/activity/jjxdpromotion' //活动页
import gjpromotion from '@/pages/activity/gjpromotion' //活动页
import novgepromotion from '@/pages/activity/novgepromotion' //活动页
import sdpromotion from '@/pages/activity/sdpromotion' //活动页
import nhjpromotion from '@/pages/activity/nhjpromotion' //活动页
import qrjpromotion from '@/pages/activity/qrjpromotion' //活动页
import fnjpromotion from '@/pages/activity/fnjpromotion' //活动页
import kfpromotion from '@/pages/activity/kfpromotion' //活动页
import jzpromotion from '@/pages/activity/jzpromotion' //活动页
import ldjpromotion from '@/pages/activity/ldjpromotion' //活动页
import mayTwenty from '@/pages/activity/mayTwenty' //活动页
import mayTwenty2 from '@/pages/activity/mayTwenty2' //活动页







import washandcareArt from "@/pages/activity/washandcareArt"; //洗护艺术







import submitOrder from '@/pages/submitOrder/submitOrder' //下单
// import loading from '@/components/submitOrder/loading' //loading
import submitcardOrder from '@/pages/submitOrder/submitcardOrder' //下单

//积分卡
import pointInvest from '@/pages/Integral/pointInvest' //积分充值
import text from '@/pages/Integral/text' //积分充值
import activation from '@/pages/Integral/activation' //卡券激活步骤3
import Activationsuccessful from '@/pages/Integral/Activationsuccessful' //激活成功
import examine from '@/pages/Integral/examine' //审核成功
import Integralcard from '@/pages/Integral/Integralcard' //扫码进入


Vue.use(Router)
Vue.use(require('vue-wechat-title')); //实例化参数
const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {


	return originalPush.call(this, location).catch(err => err)

}
export default new Router({
	routes: [
		{
			path: "/",
			component: index2,
			redirect: {
				path: "/index2"
			}
		},
		{
			path: '/order',
			name: "我的订单",
			component: order,
			meta: {
				showTab: false,
				index: 3,
				title: "我的订单"
			}
		},

		{
			path: '/notice',
			name: "公告",
			component: notice,
			meta: {
				showTab: false,
				index: 3,
				title: "公告"
			}
		},
		{
			path: '/noticedetail',
			name: "公告详情",
			component: noticedetail,
			meta: {
				showTab: false,
				index: 3,
				title: "公告详情"
			}
		},
		{
			path: '/index',
			name: "积分商城首页",
			component: index,
			meta: {
				showTab: false,
				index: 3,
				title: "积分商城首页"
			}
		},
		{
			path: '/index2',
			name: "积分商城首页",
			component: index2,
			meta: {
				showTab: false,
				index: 3,
				title: "积分商城首页"
			}
		},
		{
			path: '/classification',
			name: "分类",
			component: classification,
			meta: {
				showTab: false,
				index: 3,
				title: "分类"
			}
		},
		{
			path: '/ShoppingCart',
			name: "购物车",
			component: ShoppingCart,
			meta: {
				showTab: false,
				index: 3,
				title: "购物车"
			}
		},
		{
			path: '/my',
			name: "我的",
			component: my,
			meta: {
				showTab: false,
				index: 3,
				title: "我的"
			}
		},
		{
			path: '/customerservice',
			name: "客服",
			component: customerservice,
			meta: {
				showTab: false,
				index: 3,
				title: "客服"
			}
		},
		{
			path: '/helpCenter',
			name: "帮助中心",
			component: helpCenter,
			meta: {
				showTab: false,
				index: 3,
				title: "帮助中心"
			}
		},
		{
			path: '/newPeple',
			name: "新手上路",
			component: newPeple,
			meta: {
				showTab: false,
				index: 3,
				title: "新手上路"
			}
		},{
			path: '/disturb',
			name: "配送服务",
			component: disturb,
			meta: {
				showTab: false,
				index: 3,
				title: "配送服务"
			}
		},{
			path: '/service',
			name: "售后服务",
			component: service,
			meta: {
				showTab: false,
				index: 3,
				title: "售后服务"
			}
		},{
			path: '/haibei',
			name: "海贝计划",
			component: haibei,
			meta: {
				showTab: false,
				index: 3,
				title: "海贝计划"
			}
		},
		{
			path: '/cardlist',
			name: "实物卡列表",
			component: cardlist,
			meta: {
				showTab: false,
				index: 3,
				title: "实物卡列表"
			}
		},
		{
			path: '/cardDetail',
			name: "实物卡详情",
			component: cardDetail,
			meta: {
				showTab: false,
				index: 3,
				title: "实物卡详情"
			}
		},
		{
			path: '/Integralcard',
			name: "扫码进入",
			component: Integralcard,
			meta: {
				showTab: false,
				index: 3,
				title: "扫码进入",
				isScan: true
			}
		},
		{
			path: '/pointInvest',
			name: "积分充值",
			component: pointInvest,
			meta: {
				showTab: false,
				index: 3,
				title: "积分充值"
			}
		},
		{
			path: '/text',
			name: "积分充值",
			component: text,
			meta: {
				showTab: false,
				index: 3,
				title: "测试页面"
			}
		},
		{
			path: '/activation',
			name: "激活步骤3",
			component: activation,
			meta: {
				showTab: false,
				index: 3,
				title: "激活步骤3"
			}
		},
		{
			path: '/Activationsuccessful',
			name: "激活成功",
			component: Activationsuccessful,
			meta: {
				showTab: false,
				index: 3,
				title: "激活成功"
			}
		},
		{
			path: '/examine',
			name: "审核成功",
			component: examine,
			meta: {
				showTab: false,
				index: 3,
				title: "审核成功"
			}
		},

		{
			path: '/orderDetails',
			name: "订单详情",
			component: orderDetails,
			meta: {
				showTab: false,
				index: 3,
				title: "订单详情"
			}
		},
		{
			path: '/exchange',
			name: "退换货",
			component: exchange,
			meta: {
				showTab: false,
				index: 3,
				title: "退换货"
			}
		},
		{
			path: '/product',
			name: '商品',
			component: resolve => (require(["@/modules/product/product"], resolve)),
			children: [{
				path: 'seckill',
				name: "收货地址",
				component: seckill,
				meta: {
					showTab: false,
					index: 3,
					title: "收货地址"
				}
			}]
		},
		{
			path: '/orders',
			name: '订单',
			component: resolve => (require(["@/modules/orders/orders"], resolve)),
			children: [

				{
					path: 'toexamine',
					name: "审核资料",
					component: toexamine,
					meta: {
						showTab: false,
						index: 2,
						title: "审核资料"
					}
				},
				{
					path: 'Extractcarmine',
					name: "虚拟商品",
					component: Extractcarmine,
					meta: {
						showTab: false,
						index: 2,
						title: "虚拟商品"
					}
				},


				{
					path: 'personalinformation',
					name: "个人资料",
					component: personalinformation,
					meta: {
						showTab: false,
						index: 2,
						title: "个人资料"
					}
				},
				{
					path: 'personaldata',
					name: "个人信息",
					component: personaldata,
					meta: {
						showTab: false,
						index: 2,
						title: "个人信息"
					}
				},
				{
					path: 'Emptycollection',
					name: "空收藏",
					component: Emptycollection,
					meta: {
						showTab: false,
						index: 2,
					}
				},
				{
					path: 'Collection',
					name: "我的收藏",
					component: Collection,
					meta: {
						showTab: false,
						index: 2,
						title: "我的收藏"
					}
				},
				{
					path: 'Aftermarket',
					name: "申请售后6.1",
					component: Aftermarket,
					meta: {
						showTab: false,
						index: 2,
						title: "申请售后"
					}
				},
				{
					path: 'onlyRefund',
					name: "售后服务6.4",
					component: onlyRefund,
					meta: {
						showTab: false,
						index: 2,
						title: "申请售后"
					}
				},
				{
					path: 'afterservice',
					name: "售后服务6.4",
					component: afterservice,
					meta: {
						showTab: false,
						index: 2,
						title: "售后服务"
					}
				},
				{
					path: 'Applyreturn',
					name: "申请中退货中",
					component: Applyreturn,
					meta: {
						showTab: false,
						index: 2,
					}
				},

				{
					path: 'Applying',
					name: "退款信息(填写物流)",
					component: Applying,
					meta: {
						showTab: false,
						index: 2,
					}
				},
				{
					path: 'Returning',
					name: "物流退货中",
					component: Returning,
					meta: {
						showTab: false,
						index: 2,
						title: "物流退货中"
					}
				},
				{
					path: 'Refundclosed',
					name: "售后退款关闭2",
					component: Refundclosed,
					meta: {
						showTab: false,
						index: 2,
						title: "退款关闭"
					}
				},
				{
					path: 'Refundsuccessful',
					name: "退款成功",
					component: Refundsuccessful,
					meta: {
						showTab: false,
						index: 2,
						title: "退款成功"
					}
				},
				{
					path: 'Aftersale',
					name: "售后退款关闭",
					component: Aftersale,
					meta: {
						showTab: false,
						index: 2,
						title: "退款关闭"
					}
				},
				{
					path: 'allComments',
					name: "全部评论",
					component: allComments,
					meta: {
						showTab: false,
						index: 2,
						title: "全部评论"
					}
				},
				{
					path: 'logistics',
					name: "跟踪物流",
					component: logistics,
					meta: {
						showTab: false,
						index: 2,
						title: "跟踪物流"
					}
				},
				{
					path: 'equity',
					name: "权益详情",
					component: equity,
					meta: {
						showTab: false,
						index: 2,
						title: "权益详情"
					}
				},
				{
					path: 'evaluatingCommodities',
					name: "评价商品",
					component: evaluatingCommodities,
					meta: {
						showTab: false,
						index: 2,
						title: "评价商品"
					}
				},
				{
					path: 'search',
					name: "搜索",
					component: search,
					meta: {
						showTab: false,
						index: 2,
						title: "搜索"
					}
				},

				{
					path: 'paymentSuccessful',
					name: "支付成功",
					component: paymentSuccessful,
					meta: {
						showTab: false,
						index: 2,
						title: "支付成功"
					}
				},
				{
					path: 'invoice',
					name: "发票",
					component: invoice,
					meta: {
						showTab: false,
						index: 2,
						title: "发票"
					}
				},
				{
					path: 'shippingAddress',
					name: "收货地址",
					component: shippingAddress,
					meta: {
						showTab: false,
						index: 3,
						title: "收货地址",
					}
				},
				{
					path: 'editAddress',
					name: "编辑收货地址",
					component: editAddress,
					meta: {
						showTab: false,
						index: 4,
						title: "编辑收货地址"
					}
				},
				{
					path: 'editReceived',
					name: "修改收货地址",
					component: editReceived,
					meta: {
						showTab: false,
						index: 4,
						title: "修改收货地址"
					}
				},


			]
		},

		{
			path: '/productList',
			name: "商品列表",
			component: productList,
			meta: {
				showTab: false,
				index: 3,
				title: "商品列表",
				keepAlive:true,
				isBack:false,
				top:0
			}
		},
		{
			path: '/productDetail',
			name: "商品详情",
			component: productDetail,
			meta: {
				showTab: false,
				index: 3,
				title: "商品详情"
			}
		},
		{
			path: '/productDetails',
			name: "商品详情",
			component: productDetails,
			meta: {
				showTab: false,
				index: 3,
				title: "商品详情"
			}
		},
		{
			path: '/productDetailsDiabled',
			name: "商品详情",
			component: productDetailsDiabled,
			meta: {
				showTab: false,
				index: 3,
				title: "商品详情"
			}
		},
		{
			path: '/seckillList',
			name: "秒杀专题",
			component: seckillList,
			meta: {
				showTab: false,
				index: 3,
				title: "秒杀专题"
			}
		}, {
			path: '/groupList',
			name: "拼团专题",
			component: groupList,
			meta: {
				showTab: false,
				index: 3,
				title: "拼团专题"
			}
		}, {
			path: '/shareBill',
			name: "邀请好友拼单",
			component: shareBill,
			meta: {
				showTab: false,
				index: 3,
				title: "邀请好友拼单"
			}
		},{
			path: '/giftCoupon',
			name: "商品列表",
			component: giftCoupon,
			meta: {
				showTab: false,
				index: 3,
				title: "商品列表"
			}
		},{
			path: '/givingMonth',
			name: "感恩月",
			component: givingMonth,
			meta: {
				showTab: false,
				index: 3,
				title: "感恩月"
			}
		}, {
			path: '/promotion',
			name: "双节大促",
			component: promotion,
			meta: {
				showTab: false,
				index: 3,
				title: "双节大促"
			}
		},{
			path: '/nypromotion',
			name: "新年大促",
			component: nypromotion,
			meta: {
				showTab: false,
				index: 3,
				title: "新年大促"
			}
		},{
			path: '/zqpromotion',
			name: "中秋活动",
			component: zqpromotion,
			meta: {
				showTab: false,
				index: 3,
				title: "中秋活动"
			}
		},{
			path: '/gqpromotion',
			name: "国庆活动",
			component: gqpromotion,
			meta: {
				showTab: false,
				index: 3,
				title: "国庆活动"
			}
		},{
			path: '/jjxdpromotion',
			name: "家居小电",
			component: jjxdpromotion,
			meta: {
				showTab: false,
				index: 3,
				title: "家居小电"
			}
		},{
			path: '/gjpromotion',
			name: "锅具专场",
			component: gjpromotion,
			meta: {
				showTab: false,
				index: 3,
				title: "锅具专场"
			}
		},{
			path: '/novgepromotion',
			name: "感恩节活动",
			component: novgepromotion,
			meta: {
				showTab: false,
				index: 3,
				title: "感恩节活动"
			}
		},{
			path: '/sdpromotion',
			name: "圣诞节活动",
			component: sdpromotion,
			meta: {
				showTab: false,
				index: 3,
				title: "圣诞节活动"
			}
		},{
			path: '/nhjpromotion',
			name: "年货节活动",
			component: nhjpromotion,
			meta: {
				showTab: false,
				index: 3,
				title: "年货节活动"
			}
		},{
			path: '/qrjpromotion',
			name: "情人节活动",
			component: qrjpromotion,
			meta: {
				showTab: false,
				index: 3,
				title: "情人节活动"
			}
		},{
			path: '/fnjpromotion',
			name: "女神解压专场",
			component: fnjpromotion,
			meta: {
				showTab: false,
				index: 3,
				title: "女神解压专场"
			}
		},{
			path: '/kfpromotion',
			name: "小郁金香咖啡杯限时活动",
			component: kfpromotion,
			meta: {
				showTab: false,
				index: 3,
				title: "小郁金香咖啡杯限时活动"
			}
		},{
			path: '/jzpromotion',
			name: "家装季活动",
			component: jzpromotion,
			meta: {
				showTab: false,
				index: 3,
				title: "家装季活动"
			}
		},{
			path: '/ldjpromotion',
			name: "五一出游季",
			component: ldjpromotion,
			meta: {
				showTab: false,
				index: 3,
				title: "五一出游季"
			}
		},
		{
			path: "/plus",
			name: "PLUS会员专属兑换",
			component: plus,
			meta: {
				showTab: false,
				index: 3,
				title: "PLUS会员专属兑换",
			},
		},
		{
			path: '/mayTwenty2',
			name: "夏日花式宅家场景指南",
			component: mayTwenty2,
			meta: {
				showTab: false,
				index: 3,
				title: "夏日花式宅家场景指南"
			}
		},
		{
			path: '/mayTwenty',
			name: "520活动专场",
			component: mayTwenty,
			meta: {
				showTab: false,
				index: 3,
				title: "520活动专场"
			}
		},
		{
      path: "/washandcareArt",
      name: "我的积分",
      component: washandcareArt,
      meta: {
        showTab: false,
        index: 3,
        title: "我的积分",
      },
    },{
			path: '/submitOrder',
			name: "确认订单",
			component: submitOrder,
			meta: {
				showTab: false,
				index: 3,
				title: "确认订单",
				// keepAlive: true
			}
		},
		// {
		// 	path: '/loading',
		// 	name: "loading",
		// 	component: loading,
		// 	meta: {
		// 		showTab: false,
		// 		index: 3,
		// 		title: "loading",
		// 		keepAlive: true
		// 	}
		// },
		{
			path: '/submitcardOrder',
			name: "提交订单",
			component: submitcardOrder,
			meta: {
				showTab: false,
				index: 3,
				title: "提交订单"
			}
		},

	],
	scrollBehavior(to, from, savedPosition) {
		if (to.path === '/productDetails') {
			return { x: 0, y: 0 };
		}
	}
})
